module.exports = __webpack_public_path__ + "img/brand-5.78e95d06.png";